import { PhysicalRiskScaleItem } from "@/entities/physical-risk/model/physical-risk.types"
import { t } from "i18next"
import {
  AccountRisksSettings,
  createEmptyAccountRisksSettings,
  getResidualRiskLevels,
  ResidualRiskLevel
} from "@/redux/account.types"

//Valeur par défaut pour un niveau ajouté ; les coefficients importés peuvent être décimaux.
export const SCALE_VALUE_MIN = 1

export function sortScaleItems<T extends PhysicalRiskScaleItem>(items: T[]): T[] {
  return [...items].sort((a, b) => a.value - b.value)
}

//Edition des niveaux d'un barème (parametres du compte, import du document unique)
export function editScaleItem<T extends PhysicalRiskScaleItem>(items: T[], index: number, patch: Partial<T>): T[] {
  return items.map((item, i) => (i === index ? { ...item, ...patch } : item))
}

//Nouveau niveau, juste apres celui ou l'on clique
export function addScaleItem<T extends PhysicalRiskScaleItem>(items: T[], index: number): T[] {
  const next = [...items]
  next.splice(index + 1, 0, { label: t("utils_new"), description: "", value: SCALE_VALUE_MIN } as T)
  return next
}

//Un barème garde au moins un niveau
export function removeScaleItem<T extends PhysicalRiskScaleItem>(items: T[], index: number): T[] {
  return items.length <= 1 ? items : items.filter((_, i) => i !== index)
}

//Niveaux de risque residuel edites comme un barème : le seuil du niveau i est residualRiskScale[i - 1], le premier commence a 0
export type ResidualScaleItem = PhysicalRiskScaleItem & ResidualRiskLevel

export function getResidualScaleItems(settings: AccountRisksSettings): ResidualScaleItem[] {
  const thresholds = settings.residualRiskScale?.length
    ? settings.residualRiskScale
    : createEmptyAccountRisksSettings().residualRiskScale
  return getResidualRiskLevels(settings).map((level, index) => ({
    ...level,
    description: "",
    value: index ? thresholds[index - 1] : 0
  }))
}

//Nouveau niveau apres celui ou l'on clique, avec sa couleur et son seuil, a modifier ensuite
export function addResidualScaleItem(items: ResidualScaleItem[], index: number): ResidualScaleItem[] {
  return editScaleItem(addScaleItem(items, index), index + 1, { value: items[index].value, color: items[index].color })
}

//Seuils tries, chaque niveau avec le sien ; le premier niveau (a partir de 0) reste en tete
export function sortResidualScaleItems(items: ResidualScaleItem[]): ResidualScaleItem[] {
  return [items[0], ...sortScaleItems(items.slice(1))]
}

export function getResidualSettings(items: ResidualScaleItem[]) {
  return {
    residualRiskScale: items.slice(1).map((item) => item.value),
    residualRiskLevels: items.map(({ label, color }) => ({ label, color }))
  }
}
